import React from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { CardBody, Col, Container, Input, Row, Card, Label } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  getProductCategoryByIdAPI,
  postProductCategoryAPI,
  putProductCategoryAPI,
} from "helpers/product_category_helper"
import { toast } from "react-toastify"
import { useHistory, useLocation } from "react-router-dom"
import { getUsersCraftsmanAPI } from "helpers/users_backend_helper"
import BackButton from "components/Common/BackButton"
import SButton from "components/Common/Button"

function CategoryManagement() {
  const history = useHistory()
  let location = useLocation()

  const params = new URLSearchParams(location.search)
  const id = params.get("id")

  const [status, setStatus] = React.useState("idle")
  const [formState, setFormState] = React.useState("create")

  const [formOption, setFormOption] = React.useState([
    { id: 1, value: "トラウザーズ", isChecked: false },
    { id: 2, value: "上着", isChecked: false },
  ])

  const [crafsmanOption, setCrafsmanOption] = React.useState([])

  const [field, setField] = React.useState({
    name: "",
    forms: [],
    craftsmanTypes: [],
  })

  const [customValidation, setCustomValidation] = React.useState({
    errorName: {
      status: false,
      message: "カテゴリ名 必須項目です。",
    },
    errorForms: {
      status: false,
      message: "職人種類 必須項目です。",
    },
    errorCraftsmanTypes: {
      status: false,
      message: "フォーム 必須項目です。",
    },
  })

  const onSubmit = async () => {
    let error = 0
    let defaultError = { ...customValidation }

    if (field.name === "" || !field.name) {
      defaultError = {
        ...defaultError,
        errorName: { ...defaultError.errorName, status: true },
      }

      error += 1
    }

    let tempCrafsmanOption = false,
      tempForm = false

    crafsmanOption.forEach(cr => {
      if (cr.isChecked) {
        tempCrafsmanOption = true
      }
    })

    formOption.forEach(cr => {
      if (cr.isChecked) {
        tempForm = true
      }
    })

    if (!tempCrafsmanOption) {
      defaultError = {
        ...defaultError,
        errorCraftsmanTypes: {
          ...defaultError.errorCraftsmanTypes,
          status: true,
        },
      }

      error += 1
    }

    if (!tempForm) {
      defaultError = {
        ...defaultError,
        errorForms: {
          ...defaultError.errorForms,
          status: true,
        },
      }

      error += 1
    }

    setCustomValidation(defaultError)
    if (error === 0) {
      let payload = { ...field }

      let _craft = []
      crafsmanOption.forEach(cr => {
        if (cr.isChecked) {
          _craft.push(cr.value)
        }
      })
      let _form = []
      formOption.forEach(cr => {
        if (cr.isChecked) {
          _form.push(cr.value)
        }
      })

      payload.craftsmanTypes = _craft
      payload.forms = _form
      console.log(payload)

      const categoryAPI =
        formState === "create"
          ? postProductCategoryAPI(payload)
          : putProductCategoryAPI(payload, id)

      try {
        await categoryAPI
        history.push("/master/product-category")
      } catch (error) {
        let {
          data: { errors },
        } = error.response
        errors.forEach(err => {
          let entries = Object.entries(err)
          entries.map(([key] = entry) => {
            return toast.error(`[${key}]: 必須項目です。`)
          })
        })
      }
    }
  }

  const getCraftsman = () => {
    setStatus("fetch-craftsman")
    getUsersCraftsmanAPI().then(crafts => {
      setStatus("fetch-craftsman-success")
      setCrafsmanOption(
        crafts.data.map((val, index) => {
          return { id: index + 1, value: val, isChecked: false }
        })
      )
    })
  }
  React.useEffect(() => {
    getCraftsman()
  }, [id])

  React.useEffect(() => {
    if (id) {
      setFormState("edit")
      getProductCategoryByIdAPI(id).then(dataById => {
        setField(dataById.data)

        if (crafsmanOption.length > 0) {
          let _craft = [...crafsmanOption]
          _craft.forEach(val => {
            let unique = dataById.data.craftsmanTypes.find(f => f === val.value)
            if (unique === val.value) {
              val.isChecked = true
            }
          })

          let _form = [...formOption]
          _form.forEach(val => {
            let unique = dataById.data.forms.find(f => f === val.value)
            if (unique === val.value) {
              val.isChecked = true
            }
          })

          setFormOption(_form)
          setCrafsmanOption(_craft)
        }
      })
    }
  }, [id, status])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"商品カテゴリー"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <p className="fw-bold">
                  {id ? "商品カテゴリー詳細" : "新規商品カテゴリー追加"}
                </p>
              </Col>
              <Col className="d-flex justify-content-end">
                <SButton onClick={onSubmit} className="button">
                  保存
                </SButton>
                <BackButton className="ms-2 button" />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <Row className="mb-2">
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      カテゴリ名<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  <Col md={6} className="px-1">
                    <Input
                      name="name"
                      onChange={e => {
                        setField({ ...field, name: e.target.value })

                        setCustomValidation({
                          ...customValidation,
                          errorName: {
                            ...customValidation.errorName,
                            status: false,
                          },
                        })
                      }}
                      value={field.name}
                    />
                  </Col>
                </Row>
                {customValidation.errorName.status && (
                  <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <p style={{ color: "red" }}>
                        {customValidation.errorName.message}
                      </p>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      職人種類<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  {crafsmanOption.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col md={1} className="p-1">
                          <Input
                            onClick={e => {
                              let _temp = [...crafsmanOption]
                              _temp[index].isChecked = !_temp[index].isChecked
                              setCrafsmanOption(_temp)
                              setCustomValidation({
                                ...customValidation,
                                errorCraftsmanTypes: {
                                  ...customValidation.errorCraftsmanTypes,
                                  status: false,
                                },
                              })
                            }}
                            name="craftsmanTypes"
                            type="checkbox"
                            className="p-2"
                            checked={item.isChecked}
                            disabled={formState === "edit"}
                          />
                        </Col>
                        <Col md={2} className="col-form-label">
                          <label>{item.value}</label>
                        </Col>
                      </React.Fragment>
                    )
                  })}
                </Row>
                {customValidation.errorCraftsmanTypes.status && (
                  <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <p style={{ color: "red" }}>
                        {customValidation.errorCraftsmanTypes.message}
                      </p>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      フォーム<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  {formOption.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col md={1} className="p-1">
                          <Input
                            onClick={() => {
                              let form = [...formOption]
                              form[index].isChecked = !form[index].isChecked
                              setFormOption(form)
                              setCustomValidation({
                                ...customValidation,
                                errorForms: {
                                  ...customValidation.errorForms,
                                  status: false,
                                },
                              })
                            }}
                            checked={item.isChecked}
                            name="forms"
                            type="checkbox"
                            className="p-2"
                            disabled={formState === "edit"}
                          />
                        </Col>
                        <Col md={2} className="col-form-label">
                          <label>{item.value}</label>
                        </Col>
                      </React.Fragment>
                    )
                  })}
                </Row>
                {customValidation.errorForms.status && (
                  <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <p style={{ color: "red" }}>
                        {customValidation.errorForms.message}
                      </p>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default CategoryManagement
